/**
 * Lazy Sentry loader — keeps the 248 KB vendor-sentry chunk off the
 * critical rendering path.  Call `initSentry()` after first paint so
 * the browser can render before downloading / parsing Sentry.
 */

let sentryPromise: Promise<typeof import("@sentry/react")> | null = null;

export function initSentry(): void {
  if (!import.meta.env.PROD) return;

  sentryPromise = import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    });
    return Sentry;
  });
}

/**
 * Returns the Sentry module once loaded — `null` until then.
 * Used by error boundaries that need a handle but shouldn't block render.
 */
export function getSentry(): Promise<typeof import("@sentry/react")> | null {
  return sentryPromise;
}
